jQuery( document ).ready( function () {
	function HEADER() {
		console.log( 'JTF Header Block V1.0.2' )
		this.init()
	}

	/**
	 * Default actions happening on device actions
	 */
	HEADER.prototype.init = function () {}
} )
